import { Flex, FlexCenHor } from '@/UI/styles';
import { TextSmRg } from '@/UI/AppTypography/AppTypography';
import { color, EL_COLORS } from '@/colors';
import type { TooltipProps } from '@mui/material';

export const ShortcutPairSlotProps: TooltipProps['slotProps'] = {
  tooltip: {
    sx: {
      backgroundColor: color.Black84,
      border: `1px solid ${EL_COLORS.BoxBorder}`,
      borderRadius: 1,
      padding: '2px 4px',
    },
  },
};

export const ShortcutPair = ({ label, shortcut }: { label: string; shortcut: string[] }) => (
  <FlexCenHor sx={{ gap: 1.5 }}>
    <TextSmRg color={color.White100}>{label}</TextSmRg>
    <Flex sx={{ gap: '2px', alignItems: 'center' }}>
      {shortcut.map((part, i) => (
        <TextSmRg key={i} color={color.White64_T}>
          {part}
        </TextSmRg>
      ))}
    </Flex>
  </FlexCenHor>
);
